import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Admin() {
  const { user, logout, API } = useAuth();
  const nav = useNavigate();
  const [usuarios, setUsuarios] = useState([]);
  const [historial, setHistorial] = useState([]);
  const [tab, setTab] = useState('usuarios');

  useEffect(() => {
    if (user?.rol !== 'admin') { nav('/'); return; }
    cargar();
  }, []);

  const cargar = async () => {
    const [u, h] = await Promise.all([
      axios.get(`${API}/admin/usuarios`),
      axios.get(`${API}/historial`)
    ]);
    setUsuarios(u.data);
    setHistorial(h.data);
  };

  const aprobar = async (id) => {
    await axios.put(`${API}/admin/usuarios/${id}/aprobar`);
    cargar();
  };

  const desactivar = async (id) => {
    await axios.put(`${API}/admin/usuarios/${id}/desactivar`);
    cargar();
  };

  return (
    <div style={s.page}>
      <nav style={s.nav}>
        <span style={s.brand}>🏦 ConciliaApp — Admin</span>
        <div style={s.navRight}>
          <a href="/" style={s.link}>← Volver</a>
          <button onClick={logout} style={s.btn}>Salir</button>
        </div>
      </nav>

      <div style={s.content}>
        <div style={s.tabs}>
          {[['usuarios','👥 Usuarios'],['historial','📋 Historial']].map(([k,lbl])=>(
            <button key={k} style={{...s.tab,...(tab===k?s.tabActive:{})}} onClick={()=>setTab(k)}>{lbl}</button>
          ))}
        </div>

        {tab==='usuarios' && (
          <div style={s.card}>
            <h2 style={s.title}>Gestión de usuarios</h2>
            <table style={s.table}>
              <thead>
                <tr>{['Nombre','Correo','Rol','Estado','Registro','Acciones'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {usuarios.map(u=>(
                  <tr key={u.id}>
                    <td style={s.td}>{u.nombre}</td>
                    <td style={s.td}>{u.email}</td>
                    <td style={s.td}><span style={u.rol==='admin'?s.badgeAdmin:s.badgeUser}>{u.rol}</span></td>
                    <td style={s.td}><span style={u.activo?s.badgeOk:s.badgePending}>{u.activo?'Activo':'Pendiente'}</span></td>
                    <td style={s.td}>{new Date(u.created_at).toLocaleDateString('es-CO')}</td>
                    <td style={s.td}>
                      {!u.activo && <button style={s.btnOk} onClick={()=>aprobar(u.id)}>Aprobar</button>}
                      {u.activo && u.rol!=='admin' && <button style={s.btnDel} onClick={()=>desactivar(u.id)}>Desactivar</button>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {tab==='historial' && (
          <div style={s.card}>
            <h2 style={s.title}>Historial de conciliaciones</h2>
            <table style={s.table}>
              <thead>
                <tr>{['Nombre','Usuario','Banco','Auxiliar','Cruzan','No cruzan','Fecha'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {historial.map(h=>(
                  <tr key={h.id}>
                    <td style={s.td}>{h.nombre}</td>
                    <td style={s.td}>{h.usuario}</td>
                    <td style={s.td}>{h.total_banco}</td>
                    <td style={s.td}>{h.total_aux}</td>
                    <td style={{...s.td,color:'#16a34a',fontWeight:600}}>{h.cruzan}</td>
                    <td style={{...s.td,color:'#dc2626',fontWeight:600}}>{h.no_cruzan_banco+h.no_cruzan_aux}</td>
                    <td style={s.td}>{new Date(h.created_at).toLocaleString('es-CO')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

const s = {
  page:{minHeight:'100vh',background:'#f8fafc',fontFamily:'system-ui,sans-serif'},
  nav:{background:'#fff',borderBottom:'1px solid #e5e7eb',padding:'0 24px',height:56,display:'flex',alignItems:'center',justifyContent:'space-between'},
  brand:{fontWeight:700,fontSize:16},
  navRight:{display:'flex',alignItems:'center',gap:12},
  link:{fontSize:13,color:'#2563eb',textDecoration:'none'},
  btn:{padding:'6px 14px',borderRadius:8,border:'1px solid #e5e7eb',background:'transparent',cursor:'pointer',fontSize:13},
  content:{padding:'24px',maxWidth:1200,margin:'0 auto'},
  tabs:{display:'flex',gap:4,marginBottom:16,borderBottom:'1px solid #e5e7eb'},
  tab:{padding:'10px 20px',border:'none',background:'none',cursor:'pointer',fontSize:14,color:'#666',borderBottom:'2px solid transparent',marginBottom:-1},
  tabActive:{color:'#111',borderBottomColor:'#2563eb',fontWeight:600},
  card:{background:'#fff',borderRadius:14,padding:'24px',border:'1px solid #e5e7eb'},
  title:{fontSize:16,fontWeight:600,marginBottom:16,margin:'0 0 16px'},
  table:{width:'100%',borderCollapse:'collapse',fontSize:13},
  th:{background:'#f8fafc',padding:'10px 14px',textAlign:'left',fontWeight:500,color:'#555',borderBottom:'1px solid #e5e7eb'},
  td:{padding:'10px 14px',borderBottom:'1px solid #f0f0f0'},
  badgeAdmin:{background:'#fef3c7',color:'#92400e',padding:'2px 8px',borderRadius:20,fontSize:11,fontWeight:600},
  badgeUser:{background:'#eff6ff',color:'#1e40af',padding:'2px 8px',borderRadius:20,fontSize:11,fontWeight:600},
  badgeOk:{background:'#dcfce7',color:'#16a34a',padding:'2px 8px',borderRadius:20,fontSize:11,fontWeight:600},
  badgePending:{background:'#fff7ed',color:'#c2410c',padding:'2px 8px',borderRadius:20,fontSize:11,fontWeight:600},
  btnOk:{padding:'4px 12px',borderRadius:6,background:'#16a34a',color:'#fff',border:'none',cursor:'pointer',fontSize:12,marginRight:6},
  btnDel:{padding:'4px 12px',borderRadius:6,background:'#dc2626',color:'#fff',border:'none',cursor:'pointer',fontSize:12},
};
